import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {useTheme} from "@mui/material/styles";

const SelectField = ({config, value, onChange, size}) => {
  const theme = useTheme();

  return (
    <FormControl size={size} variant="outlined" sx={{minWidth: config.width ?? 200}}>
      <InputLabel>{config.label}</InputLabel>
      <Select
        label={config.label}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: theme.palette.colors.background,
              color: theme.palette.text.primary
            }
          }
        }}
      >
        <MenuItem value="">{config.emptyLabel ?? "Todos"}</MenuItem>
        {config.options?.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectField;
